import type { ReactNode } from 'react';

interface CustomPillProps {
    children: ReactNode;
    color: string;
}

/** Share of the level's own color kept in the text. The colors companies pick for the top levels
 * are light (green, amber): drawn as-is on the 12%-tinted background they fall well under the
 * 4.5:1 WCAG AA ratio, so the text is darkened toward black while the pill keeps its hue. */
const TEXT_COLOR_RATIO = '70%';

export const CustomPill = ({ children, color }: CustomPillProps) => {
    return (
        <span
            className={
                'text-caption inline-flex items-center justify-center gap-[8px] rounded-full px-[12px] py-[4px] font-semibold transition-all'
            }
            style={{
                backgroundColor: `color-mix(in srgb, ${color} 12%, white)`,
                color: `color-mix(in srgb, ${color} ${TEXT_COLOR_RATIO}, black)`,
            }}
        >
            {children}
        </span>
    );
};

CustomPill.displayName = 'CustomPill';
